<template>
	<div class="no-tokens">
		<NoAPITokensIcon class="token-icon" />
		<div class="description">
			{{ $t('settings_apitokens_no_tokens_description') }}
			<a :href="$t('common_apitoken_learnmore_url')" target="_blank">
				{{ $t('common_learn_more') }}
			</a>
		</div>
	</div>
</template>

<script>
import { NoAPITokensIcon } from '@/icons'

export default {
	components: {
		NoAPITokensIcon,
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.no-tokens {
	@include flex-column-center(16px);
	font-size: 14px;
	text-align: center;
	margin-top: 60px;

	.token-icon {
		margin-bottom: 30px;
	}

	:deep(.description) {
		width: 350px;
		line-height: 27px;

		a,
		a:visited {
			color: var(--blue-300);
		}
	}

	a,
	a:visited {
		color: var(--blue-300);
		text-decoration: none;
	}
}
</style>
